import { makeStyles, Box, Typography } from "@material-ui/core";

import { COLORS } from "../../theme/colors";
import { capitalize } from "../../services/utils";

const useStyles = makeStyles(() => ({
  root: {
    display: "inline-block",
    borderRadius: 4,
    padding: "0 16px",
  },
  active: {
    backgroundColor: COLORS.green,
  },
  maintenance: {
    backgroundColor: COLORS.darks[0][25],
  },
  notWorking: {
    backgroundColor: COLORS.darks[0][25],
  },
}));

export const StatusBox = ({ status }) => {
  const classes = useStyles();

  const getStatusClass = (status) => {
    switch (status) {
      case "ACTIVE":
        return classes.active;
      case "MAINTENANCE":
        return classes.maintenance;
      case "NOT WORKING":
        return classes.notWorking;
      default:
        return classes.maintenance;
    }
  };

  return (
    <Box className={`${classes.root} ${getStatusClass(status)}`}>
      <Typography variant="body2" style={{ color: COLORS.white }}>
        {capitalize(status)}
      </Typography>
    </Box>
  );
};
